import {Material} from "@/model/material";
import {reactive} from "vue";
import {ViewCard} from "vue-waterfall-plugin-next/dist/types/types/waterfall";
import {MenuInfo} from "ant-design-vue/es/menu/src/interface";
import {ITag, MenuItem} from "@/model/materials/tags";
import {api} from "@/lib/api";
import {message} from "ant-design-vue";
import {session} from "@/model/session";

export class Main {
    readonly active = reactive({
        args: {
            toggle: false,
            openKeys: [] as string[],
            path: [] as string[],
        },
        themes: [] as ViewCard[],
        components: [] as ITag[][],
        scenes: [] as ITag[],
    });

    readonly breakPoint = {
        2980: {rowPerView: 9},
        2280: {rowPerView: 8},
        1980: {rowPerView: 7},
        1680: {rowPerView: 6},
        1380: {rowPerView: 6},
        1280: {rowPerView: 5},
        900: {rowPerView: 4},
        800: {rowPerView: 3},
        500: {rowPerView: 2},
        200: {rowPerView: 1}
    }
    private data = {loading: false}

    constructor(private readonly material: Material) {
        // 初始化参数
        const _args = localStorage.getItem('_args')
        if (_args) try {
            this.active.args = JSON.parse(_args);
            this.active.args.toggle = false;
        } catch (e) {
            console.error(e);
        }
        // 给path整形
        if (!this.active.args.path) this.active.args.path = []
        this.pathExtend(JSON.parse(JSON.stringify(material.tags.menus)), 0)
        localStorage.setItem('_args', JSON.stringify(this.active.args))
        if (this.active.args.openKeys.length == 0) {
            this.active.args.openKeys = this.active.args.path.slice(0, 2);
        }
    }

    private pathExtend(mi: MenuItem[], pathOffset: number) {
        if (mi.length == 0) {
            this.computeTheme()
            return
        }
        if (mi[0].tag.startsWith('a-')) this.active.components.push(mi.map(e => this.material.tags.tags[e.tag]))
        else if (mi[0].tag.startsWith('j_')) this.active.scenes = mi.map(e => this.material.tags.tags[e.tag])

        if (this.active.args.path.length <= pathOffset) {
            // path 没了，自动后续
            this.active.args.path.push(mi[0].tag)
            this.pathExtend(mi[0].children, ++pathOffset)
        } else {
            // path 有，检查
            const ci = mi.find(i => i.tag == this.active.args.path[pathOffset])
            if (!ci) {
                this.active.args.path.length = pathOffset
                this.pathExtend(mi[0].children, ++pathOffset)
            } else {
                this.pathExtend(ci.children, ++pathOffset)
            }
        }
    }

    onMenuChanged(menu: MenuInfo) {
        if (!menu.keyPath) return
        if (menu.keyPath.length != 2) return;
        if (menu.keyPath[1] == this.active.args.path[1]) return;
        this.active.args.path = JSON.parse(JSON.stringify(menu.keyPath))
        this.active.components = []
        this.active.scenes = []
        this.pathExtend(JSON.parse(JSON.stringify(this.material.tags.menus)), 0)
    }

    onFilterChanged(length: number, tag: string) {
        this.active.args.path = this.active.args.path.slice(0, length)
        this.active.args.path.push(tag)
        this.active.components = []
        this.active.scenes = []
        this.pathExtend(JSON.parse(JSON.stringify(this.material.tags.menus)), 0)
    }

    onTabChange(tag: string) {
        this.active.args.path[this.active.args.path.length - 1] = tag
        this.computeTheme()
    }

    private pathPreviewImageUrl(themeId: string): string {
        const arr = [
            this.active.args.path.find(e => e.startsWith('t_')),
            this.active.args.path.reverse().find(e => e.startsWith('a-')),
            this.active.args.path.reverse().find(e => e.startsWith('j_'))
        ].filter(e => e);
        return `https://static.pms.guandb.cn/media/system/preview/${themeId}!${arr.join('!')}.jpg-240p`
    }

    computeTheme() {
        this.active.themes.length = 0
        this.active.themes = Object.values(this.material.themes.data)
            .filter(i => i.tags && this.active.args.path.slice(1).every(e => i.tags.includes(e)) && i.delete_at == null)
            .map(i => ({
                src: this.pathPreviewImageUrl(i.theme_id),
                theme_id: i.theme_id,
                tags: this.active.args.path
            }))
            .sort(() => Math.random() - 0.5)
        this.active.themes.push({
            src: require('@/assets/image/empty_theme.jpg'),
            theme_id: null,
            tags: this.active.args.path
        })
        localStorage.setItem('_args', JSON.stringify(this.active.args))
        document.getElementsByClassName('content').item(0)?.scrollTo(0, 0)
    }

    async create(tags: string[], themeId: string | null) {
        if (this.data.loading) {
            message.warning('加载中')
            return
        }
        this.data.loading = true
        return Promise.all([
            message.loading('加载中',3),
            api({url: `user/${session.agent?.meta.account.agent_id}/activity`, method: 'POST', data: {tags: tags, theme_id: themeId}})
        ]).then((rs) => {
            console.log(rs[1])
        }).finally(() => {
            this.data.loading = false
        })
    }
}
